import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { Rental } from '@tokeet/tv3-platform'
import { TokeetImage } from '@tv3/models/rental/tokeet-image'
import { RentalService } from '@tokeet/tv3-platform'
import * as R from 'ramda'

@Component({
  selector: 'app-rental-image',
  template: `
    <img
      *ngIf="mainImage"
      class="rental-img"
      [src]="mainImage | imageUrl | resizeImg: size * 1.5"
      [ngStyle]="{ 'width.px': size, 'height.px': size }"
    />
    <app-avatar *ngIf="!mainImage" class="rental-avatar" [text]="rental.name" [size]="size"> </app-avatar>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .rental-img {
        border-radius: 50%;
      }
    `,
  ],
})
export class RentalImageComponent implements OnChanges {
  @Input() rental: Rental = null
  @Input() size = 35

  mainImage: TokeetImage = null

  constructor(private rentalService: RentalService) {}

  ngOnChanges(changes: SimpleChanges) {
    this.rental = R.pathOr(this.rental, ['rental', 'currentValue'], changes)
    this.mainImage = this.rentalService.getMainImage(this.rental)
  }
}
